﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartVaultManagerABI = void 0;
class SmartVaultManagerABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "llVaultManager_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "feeRecipient_",
                        "type": "address"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousManager",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newManager",
                        "type": "address"
                    }
                ],
                "name": "ManagmentshipTransferred",
                "type": "event"
            },
            {
                "anonymous": false,
                "inputs": [
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "previousOwner",
                        "type": "address"
                    },
                    {
                        "indexed": true,
                        "internalType": "address",
                        "name": "newOwner",
                        "type": "address"
                    }
                ],
                "name": "OwnershipTransferred",
                "type": "event"
            },
            {
                "stateMutability": "payable",
                "type": "fallback"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "smartVaultAddress_",
                        "type": "address"
                    }
                ],
                "name": "addSmartVault",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "sourceVault_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "targetVault_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "ownFunds_",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxMainFee_",
                        "type": "uint256"
                    }
                ],
                "name": "changeSmartVault",
                "outputs": [],
                "stateMutability": "payable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "feeCorrectinIndex",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "feeRecipient",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "flashLoanAdditionalFee",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "flashLoanCallback",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "flashLoaner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llBorrower",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llUsdlERC20",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "llVaultManager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "manager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "owner",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "smartVaultAddress_",
                        "type": "address"
                    }
                ],
                "name": "removeSmartVault",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "feeCorrectinIndex_",
                        "type": "uint256"
                    }
                ],
                "name": "setFeeCorrectinIndex",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "feeRecipient_",
                        "type": "address"
                    }
                ],
                "name": "setFeeRecipient",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "flashLoanAdditionalFee_",
                        "type": "uint256"
                    }
                ],
                "name": "setFlashLoanAdditionalFee",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "flashLoaner_",
                        "type": "address"
                    }
                ],
                "name": "setFlashLoaner",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "name": "smartVaults",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "name": "smartVaultsHash",
                "outputs": [
                    {
                        "internalType": "bool",
                        "name": "",
                        "type": "bool"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newManager_",
                        "type": "address"
                    }
                ],
                "name": "transferManagmentship",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "newOwner_",
                        "type": "address"
                    }
                ],
                "name": "transferOwnership",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "skip",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "_forAddress",
                        "type": "address"
                    }
                ],
                "name": "viewSmartVaults",
                "outputs": [
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "debt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "coll",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "totalDebt",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "FCRIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "redeemDeltaDebtIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "redeemDeltaCollIndex",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "debtForRepay",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "plsvBalance",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "plsvSupply",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "totalLiqidatedColl",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "closeVaultTimestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "address",
                                "name": "addrs",
                                "type": "address"
                            },
                            {
                                "internalType": "string",
                                "name": "name",
                                "type": "string"
                            },
                            {
                                "internalType": "bool",
                                "name": "isLiquidated",
                                "type": "bool"
                            },
                            {
                                "internalType": "bool",
                                "name": "needExtSync",
                                "type": "bool"
                            }
                        ],
                        "internalType": "struct ISmartVaultForManager.SmartVaultFullInfo[25]",
                        "name": "infos",
                        "type": "tuple[25]"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "withdraw",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "erc20Address",
                        "type": "address"
                    }
                ],
                "name": "withdrawToken",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            },
            {
                "stateMutability": "payable",
                "type": "receive"
            }
        ];
    }
}
exports.SmartVaultManagerABI = SmartVaultManagerABI;
//# sourceMappingURL=SmartVaultManagerABI.js.map